import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import * as thunks from './thunks';
import {
  GetSellOutRequest,
  SellOutListData,
  SellOutSummaryData
} from './types';
import { PaginationV2 } from 'src/types';

type State = {
  sell_out_list: SellOutListData[];
  sell_out_summary: SellOutSummaryData;
  is_loading: boolean;
  meta: PaginationV2;
  params: GetSellOutRequest;
};

const initialState: State = {
  sell_out_list: [],
  sell_out_summary: {},
  meta: { current_page: 1 },
  is_loading: false,
  params: { page: 1 }
};

const slice = createSlice({
  name: 'sell-out',
  initialState,
  reducers: {
    sellOutParams: (state, { payload }: PayloadAction<GetSellOutRequest>) => {
      state.params = payload;
    }
  },
  extraReducers(builder) {
    builder.addCase(thunks.getSellOutListThunk.pending, (state) => {
      state.is_loading = true;
    });
    builder.addCase(
      thunks.getSellOutListThunk.fulfilled,
      (state, { payload }) => {
        state.sell_out_list = payload?.originalData?.data || [];
        state.meta = payload?.originalData?.meta || initialState.meta;
        state.is_loading = false;
      }
    );
    builder.addCase(thunks.getSellOutListThunk.rejected, (state) => {
      state.is_loading = false;
    });

    builder.addCase(thunks.getSellOutSummaryThunk.pending, (state) => {
      state.is_loading = true;
    });
    builder.addCase(
      thunks.getSellOutSummaryThunk.fulfilled,
      (state, { payload }) => {
        state.sell_out_summary = payload?.originalData?.data || {};
        state.is_loading = false;
      }
    );
    builder.addCase(thunks.getSellOutSummaryThunk.rejected, (state) => {
      state.is_loading = false;
    });
  }
});

export const reducer = slice.reducer;

export const actions = {
  ...slice.actions,
  ...thunks
};
